export interface SalesDespatchNoteStatus {
  id: string;
  description: string;
  colour: string;
}
